import { render } from "./ArticleItem.vue?vue&type=template&id=0bd97000"
import script from "./ArticleItem.vue?vue&type=script&lang=js"
export * from "./ArticleItem.vue?vue&type=script&lang=js"

import "./ArticleItem.vue?vue&type=style&index=0&id=0bd97000&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__